import React from "react"
import _ from "lodash"
import SampleWaveform from "./SampleWaveform"
import { styled } from "@mui/material/styles"
import { titleize, truncateWords, pluralize } from "../utils/stringUtils"
import { observer } from "mobx-react"

const SampleWaveformCollectionContainer = styled('div')`
  height: 42px;
  position: relative;
`

@observer
export default class CollectionCard extends React.Component {

  render() {
    const { collection } = this.props
    const {
      name,
      imageThumbUrl,
      samplesPublishedCount,
      collectionUrl,
      samplesToPreview,
    } = collection

    const collectionNameToDisplay = truncateWords(titleize(name), 5)

    return (
      <div className="collection-card col m3 s6 l3">

        <div className="card">
          <div className="card-image waves-effect waves-block waves-light">
            { imageThumbUrl ?
              <img src={imageThumbUrl} alt="Collection card image"/> :
              <img src='sexy_waveform.jpg' alt="Default waveform image"/>
            }
          </div>

          <div className="card-content">
            <p className="flow-text">
              <span className="activator collection-title" role="heading">{collectionNameToDisplay}</span>
            </p>
            <p>
              <a href={collectionUrl}>
                {`${samplesPublishedCount} samples`}
              </a>
            </p>
          </div>

          <div className="card-reveal">
            <span className="card-title grey-text text-darken-4"></span>
            <a href={collectionUrl}>
              <span className="black-text flow-text collection-title-reveal" role="heading">{collectionNameToDisplay}</span>
            </a>
            <a href={collectionUrl}>
              <ul className="collection">
                {samplesToPreview.map( sample => {
                  return (
                    <SampleWaveformCollectionContainer key={sample.slug}>
                      <SampleWaveform
                        sample={sample}
                        shouldRenderTimestampsIfMod={false}
                      />
                    </SampleWaveformCollectionContainer>
                  )
                })}
              </ul>
              <span className="samples-text">
               + {samplesPublishedCount - 3} more {pluralize(samplesPublishedCount, 'sample')}
              </span>
            </a>
          </div>

        </div>
      </div>
    )
  }
}
